import { Button } from '@components/common';
import React from 'react';
import { RefundPostingRuleTemplate } from './refundPostingRules';

interface RefundRuleScenarioCardProps {
  template: RefundPostingRuleTemplate;
  configuredRules: number;
  onCreateRule: (template: RefundPostingRuleTemplate) => void;
}

export function RefundRuleScenarioCard({
  template,
  configuredRules,
  onCreateRule,
}: RefundRuleScenarioCardProps) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-gray-900">
            {template.title}
          </h3>
          <p className="mt-1 text-sm text-gray-600">{template.description}</p>
        </div>
        <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700">
          {configuredRules} rule{configuredRules === 1 ? '' : 's'}
        </span>
      </div>

      <div className="mt-4 flex items-center justify-between gap-3">
        <div className="text-xs uppercase tracking-wide text-gray-500">
          {template.sourceModule.replace('_', ' ')} · {template.eventType}
        </div>
        <Button size="sm" onClick={() => onCreateRule(template)}>
          Add rule
        </Button>
      </div>
    </div>
  );
}
